import React, { FunctionComponent, PropsWithChildren } from 'react';
import { CalendarContextProvider } from '../../contexts/CalendarContext';
import styles from './styles.module.scss';
import classNames from 'classnames';

export type CalendarProps = PropsWithChildren<{
    timezone?: string;
    locale?: string;
    className?: string;
    style?: React.CSSProperties;
    initialDate?: Date;
    onActiveDateChanged?: (activeDate: Date) => void;
}>;

export const Calendar: FunctionComponent<CalendarProps> = ({
    timezone,
    locale,
    className,
    style,
    children,
    initialDate,
    onActiveDateChanged,
}) => {
    return (
        <CalendarContextProvider
            timezone={timezone}
            locale={locale}
            initialDate={initialDate}
            onActiveDateChanged={onActiveDateChanged}
        >
            <section className={classNames(styles.container, className)} style={style}>
                {children}
            </section>
        </CalendarContextProvider>
    );
};
